// TODO https://app.asana.com/1/60604373080989/project/1207203365740563/task/1210069996393139?focus=true

const playStoreLink = 'https://play.google.com/store/apps/details?id=com.yfabrik.hocknfinder';
const appStoreLink = 'https://apps.apple.com/at/app/hokify-jobsuche-bewerbung/id1069568033';

/**
 * Returns the user agent string of the current browser.
 *
 * @returns The user agent string or undefined if not in a browser environment.
 */
function getUserAgent(): string | undefined {
	if (typeof window === 'undefined') {
		return undefined;
	}

	return navigator?.userAgent ?? navigator?.vendor ?? (window as { opera?: string }).opera;
}

/**
 * Determines the mobile operating system based on the user agent.
 *
 * Note: Only works in a browser environment.
 *
 * @returns 'ios' if the device is an iOS device, 'android' if it is an Android device.
 */
function getMobileOperatingSystem(): 'ios' | 'android' {
	if (process.server) {
		return 'android';
	}

	const userAgent = getUserAgent();

	if (
		[
			'iPad Simulator',
			'iPhone Simulator',
			'iPod Simulator',
			'iPad',
			'iPhone',
			'iPod',
			'MacIntel'
		].includes(navigator?.platform) ||
		userAgent?.includes('Mac')
	) {
		return 'ios';
	}

	return 'android';
}

/**
 * Returns the app download link based on the mobile operating system.
 *
 * @param mobileOs - Optional parameter to specify the mobile operating system ('ios' or 'android').
 *   If not provided, it will be determined automatically.
 * @returns The download link for the respective app store.
 */
export function getAppDownloadLink(mobileOs?: 'ios' | 'android'): string {
	const os = mobileOs || getMobileOperatingSystem();

	if (os === 'ios') {
		return appStoreLink;
	}

	return playStoreLink;
}
